import React from 'react'
import MyComponent from '../MyComponent';
import shortid from "shortid";
import "./ContentRuleFolder.scss"
import { useState } from 'react';


function ContentRuleFolder({ containerObject, templateName, contentId, dataZone, parentAttributes }) {
  const [toggleState, setToggleState] = useState(0)
  

  const toggleTab = (index) => {
    setToggleState(index)
  }
  

  
  return (
    <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId}
   
      data-template-name={templateName} className="vast-plugin-content plugin-name row gx-0 "
      plugin-name={containerObject.attributes ? containerObject.attributes.folderName : ''}>
      {/* <h6>{containerObject && containerObject.attributes ? containerObject.attributes.folderName :""}</h6> */}
      {/* displaying satisfied rule content */}
      
      {parentAttributes && parentAttributes.renderAsTab &&  parentAttributes.renderAsTab == "Y" ?
        <>
          <ul class="bloc-tabs">
            {containerObject && containerObject.childRules && containerObject.childRules.map((oneRule, index) => {
              let content = oneRule.ContentRuleZone[0];
              let childRuleType = oneRule.pageTitle;
              return (
                <li class="nav-item">
                  <div className={`${toggleState === index ? "active-tabs" : "tabs"}`}
                    onClick={() => toggleTab(index)}>{childRuleType}</div>
                </li >
              )
            }
            )}
          </ul>

          {containerObject && containerObject.childRules && containerObject.childRules.map((oneRule, index) => {
            let oneContent = oneRule.ContentRuleZone[0];
            let childRuleType = oneContent['@type'];
            let ruleTypeContentId = oneContent.contentId;
            return (
              <div className='content-tabs'>
                <div className={`content-rule ${toggleState === index ? "content active-content" : "tab-content-plugin"}`}>
                  <MyComponent type={childRuleType} key={shortid.generate()} containerObject={oneContent} contentId={ruleTypeContentId} dataZone={childRuleType} templateName={childRuleType} />
                </div>
              </div>
            )
          }
          )}
        </>
        :
        containerObject && containerObject.childRules && containerObject.childRules.map((oneRule, index) => {
          let content = oneRule.ContentRuleZone[0];
          let childRuleType = content['@type'];
          let templateType = content.templateType;
          let ruleTypeContentId = content.contentId;
		let contentWidth =''
			if(content.attributes){
				contentWidth = content.attributes.articleContainerRendering?content.attributes.articleContainerRendering:"";
			}
       //   let contentWidth = content.attributes.articleContainerRendering?content.attributes.articleContainerRendering:"";
          console.log("contentWidth",contentWidth)
          if (templateType == "page") {
            return (
              <span className='content-rule'>
                <MyComponent type={childRuleType} key={shortid.generate()} state={content} contentId={ruleTypeContentId} dataZone={childRuleType} templateName={childRuleType} />
              </span>
            )
          } else {
            return (
              <span className={`content-rule plugin-rule-folder ${contentWidth}`}>
                <MyComponent type={childRuleType} key={shortid.generate()} containerObject={content} contentId={ruleTypeContentId} dataZone={childRuleType} templateName={childRuleType} />
              </span>
            )
          }
        }
        )
      }
    </div>
  )
}
export default ContentRuleFolder
